/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateSessionParamsDTO } from './CreateSessionParamsDTO';
import {
    CreateSessionParamsDTOFromJSON,
    CreateSessionParamsDTOFromJSONTyped,
    CreateSessionParamsDTOToJSON,
} from './CreateSessionParamsDTO';

/**
 * 
 * @export
 * @interface MonitoringHoursPurchaseRequestDTO
 */
export interface MonitoringHoursPurchaseRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof MonitoringHoursPurchaseRequestDTO
     */
    additionalHours: number;
    /**
     * 
     * @type {CreateSessionParamsDTO}
     * @memberof MonitoringHoursPurchaseRequestDTO
     */
    sessionParams: CreateSessionParamsDTO;
}

/**
 * Check if a given object implements the MonitoringHoursPurchaseRequestDTO interface.
 */
export function instanceOfMonitoringHoursPurchaseRequestDTO(value: object): value is MonitoringHoursPurchaseRequestDTO {
    if (!('additionalHours' in value) || value['additionalHours'] === undefined) return false;
    if (!('sessionParams' in value) || value['sessionParams'] === undefined) return false;
    return true;
}

export function MonitoringHoursPurchaseRequestDTOFromJSON(json: any): MonitoringHoursPurchaseRequestDTO {
    return MonitoringHoursPurchaseRequestDTOFromJSONTyped(json, false);
}

export function MonitoringHoursPurchaseRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoringHoursPurchaseRequestDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'additionalHours': json['additionalHours'],
        'sessionParams': CreateSessionParamsDTOFromJSON(json['sessionParams']),
    };
}

export function MonitoringHoursPurchaseRequestDTOToJSON(value?: MonitoringHoursPurchaseRequestDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'additionalHours': value['additionalHours'],
        'sessionParams': CreateSessionParamsDTOToJSON(value['sessionParams']),
    };
}

